/**
 * Enums: 共用定義
 * @module CommonEnums
 */
/**
 * 取得用於i18next的stringValue
 * @param {Object} Enum 欲查詢的EnumObject
 * @param {*} value 欲查詢的enumValue
 * @returns {String}
 */
function _getStringValue(Enum, value) {
  const key = Object.keys(Enum).find((_key) => Enum[_key].value === value);
  return key && Enum[key].stringValue;
}

/**
 * 取得此Enumeration的所有value
 * @param {Object} Enum 欲取得value的EnumObject
 * @returns {Array}
 */
function _getValues(Enum) {
  return Object.keys(Enum).map(
    (enumKey) => Enum[enumKey].value || Enum[enumKey],
  );
}

const _StatusEnums = {
  ACTIVE: {value: 'A', stringValue: '有效'},
  INACTIVE: {value: 'I', stringValue: '無效'},
  BLACKLIST: {value: 'B', stringValue: '黑名單'},
  PERMITING: {value: 'P', stringValue: '待核可'},
  ENABLE: {value: 'A', stringValue: '啟用'},
  DISABLE: {value: 'I', stringValue: '停用'},
};

const _YesNoEnums = {
  YES: {value: '1', stringValues: '是'},
  NO: {value: '0', stringValues: '否'},
};

const _ApplicantTypeEnums = {
  RESIDENT: {value: 'R', stringValue: '住戶'},
  VISITOR: {value: 'V', stringValue: '訪客'},
  EMPLOYEE: {value: 'E', stringValue: '員工'},
  BUSINESS_OWNER: {value: 'B', stringValue: '業主'},
  OTHER: {value: 'O', stringValue: '其他'},
};

const _SocketMessageEnums = {
  NEW_CONTROL_COMMAND: {
    value: 'new_control_command',
    stringValue: '新增梯控命令',
  },
  NEW_APPLICATION: {value: 'new_application', stringValue: '新增梯控申請'},
  SYNC_MAC: {value: 'sync_mac', stringValue: '同步MAC'},
  // for user management
  UPDATE_ROLE_PERMISSION: {
    value: 'update_role_permission',
    stringValue: '更新角色權限',
  },
  UPDATE_USER_ROLE: {value: 'update_user_role', stringValue: '更新使用者角色'},
  DISABLE_USER: {value: 'disable_user', stringValue: '停用使用者'},
  UPDATE_USER_PASSWORD: {
    value: 'update_user_password',
    stringValue: '更新使用者密碼',
  },
};

const _flgStatusEnums = {
  CLOSE: {value: 'C', stringValue: '已處理'},
  OPEN: {value: 'O', stringValue: '未處理'},
};

const _satisfactionflgStatusEnum = {
  CLOSE: {value: 'A', stringValue: '待處理'},
  OPEN: {value: 'E', stringValue: '已寄送'},
  FINISH: {value: 'F', stringValue: '已處理'},
};
const _assignmentflgStatusEnum = {
  CLOSE: {value: 'A', stringValue: '已派工待處理'},
  OPEN: {value: 'P', stringValue: '執行中'},
  DRAFT: {value: 'D', stringValue: '草稿'},
  FINISH: {value: 'F', stringValue: '已完成'},
};
const _caseTypeEnums = {
  install: {value: 1, stringValue: '安裝/試車'},
  repair: {value: 2, stringValue: '修理'},
  retrofit: {value: 3, stringValue: '改造'},
  maintenance: {value: 4, stringValue: '保養'},
  support: {value: 5, stringValue: '技術支援'},
  other: {value: 6, stringValue: '其他'},
};

const EmployeeAreaEnums = {
  NORTH: {value: 1, stringValue: '北區'},
  CENTER: {value: 10, stringValue: '中區'},
  SOUTH: {value: 16, stringValue: '南區'},
};

exports.StatusEnums = _StatusEnums;
exports.YesNoEnums = _YesNoEnums;
exports.ApplicantTypeEnums = _ApplicantTypeEnums;
exports.SocketMessageEnums = _SocketMessageEnums;
exports.flgStatusEnums = _flgStatusEnums;
exports.satisfactionflgStatusEnum = _satisfactionflgStatusEnum;
exports.assignmentflgStatusEnum = _assignmentflgStatusEnum;
exports.EmployeeAreaEnums = EmployeeAreaEnums;
exports.caseTypeEnums = _caseTypeEnums;
